module.exports = "<ng-template [ngIf]=\"!isLoading\">\n    <div class=\"user-define-popup-container\">\n        <lfwms-result-data-table          \n            [searchService]=\"searchService\"\n            [tableMode]=\"tableMode\"\n            (buttonActionHandler)=\"handleButtonAction($event)\" \n           >\n        </lfwms-result-data-table>\n    </div>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/common/userdefinefields-popup/user-define-popup.component.html
// module id = ../../../../../src/app/shared/components/common/userdefinefields-popup/user-define-popup.component.html
// module chunks = main